export default "__VITE_ASSET__DCqveOjf__"